module.exports = __webpack_public_path__ + "static/Logo-transparent-d7c331b9c6b40cc398b73e9572aa2cfd.svg";